import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rili",
  "use": "rili-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rili\"><path d=\"M864 192H704v-64h-64v64H384v-64h-64v64H160c-17.6 0-32 14.4-32 32v640c0 17.6 14.4 32 32 32h704c17.6 0 32-14.4 32-32V224c0-17.6-14.4-32-32-32zm-32 640H192V384h640v448zM384 512H256v-64h128v64zm192 0H448v-64h128v64zm192 0H640v-64h128v64zM384 640H256v-64h128v64zm192 0H448v-64h128v64zm192 0H640v-64h128v64zM384 768H256v-64h128v64zm192 0H448v-64h128v64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol